export const validate_new_company_form = (values) => {
    let errors = {
        company_name: "",
        bullstat: "",
        accountable_person: "",
        address: "",
        city: "",
        phone: "",
        company_note: "",
    }

    if (!values.company_name) {
        errors.company_name = "Попълването на име на юридическо лице е задължително";
    }

    if (!values.bullstat) {
        errors.bullstat = "Попълването на БУЛСТАТ е задължително";
    } else if (values.bullstat.length < 9 || values.bullstat.length > 10) {
        errors.bullstat = "Трябва да бъде 9 или 10 цифри";
    }

    return errors;
};